// @flow
import styled, { css } from 'styled-components'
import colors from '../../styles/colors'

const Label = styled.label`
  position: relative;
  display: flex;
  ${(props) =>
    props.checked ? checkboxColor.checked : checkboxColor.unchecked};
  &:before {
    content: '';
    border-radius: 2px;
    cursor: pointer;
    position: absolute;
    left: 0;
    top: 0;
    height: 20px;
    width: 20px;
  }

  ${(props) =>
    props.checked
      ? `
    &:after {
        content: '';
        position: absolute;
        left: 7px;
        top: 2px;
        width: 7px;
        height: 14px;
        border-width: 0px 3px 3px 0;
        transform: rotate(45deg);
        cursor: pointer;
      }

  `
      : ''};

  ${(props) =>
    props.disabled
      ? `
      &:before {
        background-color: rgba(0,0,0,0.1);
        border: none;
        cursor: default;
      }
    `
      : ''};

  ${(props) =>
    props.checked && props.disabled
      ? `
   &:before {
      background-color: ${colors.orange};
      opacity: 0.3;
    }
  `
      : ''};
`

const checkboxColor = {
  unchecked: css`
    &:before {
      background-color: ${colors.white};
      border: 1px solid ${colors.light_black};
    }
    &:after {
      border: solid #fff;
    }
  `,
  checked: css`
    &:before {
      background-color: ${({ $color }) => colors[$color]};
      border: 1px solid ${({ $color }) => colors[$color]};
    }
    &:after {
      border: solid #fff;
    }
  `,
}

export default Label
